import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {selectStore} from "../../../store/selector";
import {useParams} from "react-router-dom";
import dayjs from "dayjs";
import {StyledButton, StyledSettingsContainer} from "../AdmissionView/index.styles";
import {Col, Row, Spin, Timeline} from "antd";
import {admissionStatuses} from "../../../assets/static/admissionStatuses";
import {StyledTimeline} from "./index.styles";
import {fetchAdmissionLog} from "../../../store/pages/admission/actions";
import {decodeBase64} from "../../../utils/decodeBase64";

export const AdmissionLog = () => {
    const dispatch = useDispatch();
    const {id} = useParams();
    const {t} = useTranslation(["admissionView", "executorAdmissionSteps"]);

    const {admission: {admissionLog}} = useSelector(selectStore)

    const decodedId = decodeBase64(id)

    useEffect(() => {
        //@ts-ignore
        dispatch(fetchAdmissionLog(decodedId))
    }, [id]);

    const label = (item: any) => <>
        <p style={{margin: 0}}>
            <span style={{fontWeight: 600}}>{item && item.label}</span>
        </p>
        <p style={{margin: 0}}>
            <span>{item && item.created_at && dayjs(item.created_at).format('DD.MM.YYYY, HH:MM:ss')}</span>
            <span style={{paddingLeft: 12}}>{item && item.executor.fio}</span>
        </p>
    </>

    const handleRedirect = () => {
        window.location.replace(`${process.env.REACT_APP_FULLSTACK_URL}/work-by-executor`)
    }


    return (
        <>
            <Row justify='center'>
                <Col span={20}>
                    <Row>
                        <Col span={24} style={{marginTop: 16}}>
                            <Spin spinning={!admissionLog.success}>
                                <StyledSettingsContainer style={{backgroundColor: "#fff"}}>
                                    <div className="card">
                                        <h2 style={{
                                            fontSize: 28,
                                            fontWeight: "bold",
                                            padding: "16px 32px",
                                            borderBottom: "1px solid #C4C8CB"
                                        }}>{t('admissionView:stepsCaptions.history')} {decodedId}</h2>
                                        <div style={{padding: 16}}>
                                            <Row>
                                                <Col span={18}>
                                                    <StyledTimeline mode="right">
                                                        {admissionLog.success && admissionLog.data.educationOrderHistory.map((item: any) => (
                                                            admissionStatuses.map((status: any) => {
                                                                if (parseInt(item.status) === parseInt(status.val)) {
                                                                    return <Timeline.Item
                                                                        color={(status.val === 3 || status.val === 5 || status.val === 6) ? "#DC3545" : "#51258F"}
                                                                        label={label(item)}
                                                                    >
                                                                        <span
                                                                            style={{fontWeight: 700}}>{status.name}</span>
                                                                    </Timeline.Item>
                                                                }
                                                            })
                                                        ))}
                                                    </StyledTimeline>
                                                </Col>

                                            </Row>

                                            <Row justify="space-around" className="admission__footer"
                                                 style={{borderTop: "1px solid #C4C8CB", paddingTop: 32}}>
                                                <Col className="admission__button-content">

                                                    <StyledButton
                                                        className="admission__button admission__button--item"
                                                        onClick={() => handleRedirect()}
                                                    >
                                                        {t('admissionView:stepsButton.backToList')}
                                                    </StyledButton>

                                                </Col>
                                            </Row>
                                        </div>

                                    </div>
                                </StyledSettingsContainer>
                            </Spin>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>

    )
}